var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 191,
    viewBox: "0 0 207 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2649 76.8652H50.1445V28.1948H93.2649V76.8652Z",
    fill: "#FFB81C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.033 180.609C163.033 184.924 159.537 188.424 155.229 188.424H37.9336C33.6235 188.424 30.1318 184.924 30.1318 180.609V11.4547C30.1318 7.13752 33.6235 3.63769 37.9336 3.63769H155.229C159.537 3.63769 163.033 7.13752 163.033 11.4547V53.043",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.765 112.018L160.354 168.494L135.568 152.512L124.594 145.451L161.021 88.9547L171.982 96.0363L185.128 104.514L196.765 112.018Z",
    fill: "#FFB81C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.777 92.038L129.365 148.511L118.391 141.452L154.818 84.9559L165.777 92.038Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.563 108.017L154.149 164.494L142.511 156.99L178.925 100.514L190.563 108.017Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.095 93.2525L197.81 96.7731L162.07 73.7287L164.334 70.1952C167.61 65.1105 174.395 63.6451 179.478 66.9244L196.824 78.1083C201.908 81.3847 203.374 88.1697 200.095 93.2525Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.811 96.7725L190.562 108.015L178.925 100.512L165.777 92.0364L154.818 84.9543L162.071 73.7282L197.811 96.7725Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.074 73.727L154.821 84.9531L162.054 73.714L162.074 73.727Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.924 100.514L142.51 156.99L129.364 148.512L165.776 92.0391L178.924 100.514Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.309 167.31L126.08 173.438C124.116 174.056 122.067 172.737 121.841 170.689L120.49 159.254L145.309 167.31Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.15 164.491L145.312 167.308L120.493 159.252L118.393 141.45L129.366 148.509L154.15 164.491Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0541 71.6484H44.9336V22.978H88.0541V71.6484Z",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6602 90.9521H130.015",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6602 112.781H117.302",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6602 134.609H102.774",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6602 158.257H95.5097",
    stroke: "white",
    strokeWidth: 4.85079,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselImage1);
export default __webpack_public_path__ + "static/media/CarouselImage1.576dab8c1aec2234abb773e3e5c3b5c8.svg";
export { ForwardRef as ReactComponent };